module.exports = __webpack_public_path__ + "static/media/history_32.a1c6ba85.jpg";